export const FAVOURITES_ALL_PENDING = 'waitrose/favourites/FAVOURITES_ALL_PENDING';
export const FAVOURITES_ALL_FULFILLED = 'waitrose/favourites/FAVOURITES_ALL_FULFILLED';
export const FAVOURITES_ALL_REJECTED = 'waitrose/favourites/FAVOURITES_ALL_REJECTED';

export const FAVOURITES_ALL_ACTIONS = [
  FAVOURITES_ALL_PENDING,
  FAVOURITES_ALL_FULFILLED,
  FAVOURITES_ALL_REJECTED,
] as const;
